<ng-template #defaultTabsHeader let-tabs='tabs'>
  <ul *ngIf='tabs' class='tab-panel-buttons'>
    <li (click)='selectTab(tab)' *ngFor='let tab of tabs' [ngClass]='{selected: tab.selected}'>
      {{tab.title}}
    </li>
  </ul>
</ng-template>

<ng-container
  *ngTemplateOutlet='headerTemplate ? headerTemplate : defaultTabsHeader; context: tabsContext'>
</ng-container>

<ng-content></ng-content>
